module.exports = __webpack_public_path__ + "static/paul-hogg-da3f27539064c884492c9f8a97b395ea.png";